import React, {useContext} from 'react'
import { Box } from '@mui/material'
import GalleryList from './GalleryList'
import { useStyles } from './styles'
import ImageCarousel from '../../components/ImageCarousel'
import {GalleryInfoContext} from "../../components/GalleryInfoContext";

const Gallery = () => {
  const classes = useStyles()
    const {galleryInfo} = useContext(GalleryInfoContext);

    // ✅ Transform string URLs to the format ImageCarousel expects
    const carouselSlides = React.useMemo(() => {
        const uniqueUrls = Array.from(new Set(galleryInfo?.tintedHeaderImages || []));
        return uniqueUrls.map((url, index) => ({
            id: index, // or use url as id: id: url
            image: url,
            title: "" // empty title or add appropriate title if available
        }));
    }, [galleryInfo?.tintedHeaderImages]);

  return (
    <Box className={classes.container}>
      <Box
        className={classes.margin}
        style={{
          marginTop: '150px',
        }}
      >
        <ImageCarousel slides={carouselSlides} />
      </Box>
      <GalleryList />
    </Box>
  )
}

export default Gallery
